
import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MappingResultService } from '../../../_services/mapping-result.service';
import { MatSnackBar } from '@angular/material/snack-bar';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';

// Updated to match new API response structure
export interface ApiComment {
  id: string;
  comment: string;
  updated_at: string;
  updated_by: string;
  category_name: string;
  displayTimestamp?: string;
}

export interface LocalComment {
  text: string;
  updatedBy: string;
  timestamp: string;
}
@Component({
  selector: 'app-comment-modal',
  standalone: true,
  imports: [CommonModule, FormsModule, MatIconModule],
  templateUrl: './comment-modal.component.html',
  styleUrls: ['./comment-modal.component.scss']
})

export class CommentModalComponent {
  comments: LocalComment[] = [];
  loading = false;
  previousFeedback: string | null = null;
  apiComments: ApiComment[] = [];
  apiCommentsLoading = false;
  commentCount: number = 0;

  trackByIndex(index: number, obj: any): any {
    return index;
  }

  get validCommentsCount(): number {
    return this.comments.filter(c => c.text && c.text.trim().length > 0).length;
  }

  constructor(
    private dialogRef: MatDialogRef<CommentModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private mappingResultService: MappingResultService,
    private _snackBar: MatSnackBar
  ) {
    const now = new Date().toISOString();
    this.comments = [{
      text: '',
      updatedBy: data?.updated_by || 'Unknown',
      timestamp: now
    }];
    if (data && data.doc_run_id && data.request_id && data.data_element_name) {
      const feedbackKey = `previous_feedback_comment_${data.doc_run_id}_${data.request_id}_${data.data_element_name}`;
      this.previousFeedback = localStorage.getItem(feedbackKey);
    } else {
      this.previousFeedback = null;
    }
  }

  ngOnInit(): void {
    if (this.data && Array.isArray(this.data.comments)) {
      this.apiComments = this.data.comments.slice().sort((a: any, b: any) => {
        return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
      }).map((c: any) => ({
        id: c.id,
        comment: c.comment,
        updated_at: c.updated_at,
        updated_by: c.updated_by,
        category_name: c.category_name,
        displayTimestamp: this.formatRawTimestamp(c.updated_at)
      }));
      this.commentCount = this.data.comments.length;
    } else if (this.data && this.data.comments) {
      const c = this.data.comments;
      this.apiComments = [{
        id: c.id,
        comment: c.comment,
        updated_at: c.updated_at,
        updated_by: c.updated_by,
        category_name: c.category_name
        ,displayTimestamp: this.formatRawTimestamp(c.updated_at)
      }];
      this.commentCount = 1;
    } else {
      this.apiComments = [];
      this.commentCount = 0;
    }
  }

  submit() {
    this.loading = true;
    const now = new Date().toISOString();
    const validComments = this.comments.filter(c => c.text && c.text.trim());
    const commentTexts = validComments.map(c => c.text.trim());
    const payload = {
      doc_run_id: this.data.doc_run_id,
      data_element_name: this.data.data_element_name,
      comments: commentTexts,
      updated_by: this.data.updated_by
    };
    this.mappingResultService.feedbackCommentPost(payload).subscribe({
      next: (res) => {
        if (res && Array.isArray(res.comments)) {
          this.apiComments = res.comments.slice().sort((a: any, b: any) => {
            return new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime();
          }).map((c: any) => ({
            id: c.id,
            comment: c.comment,
            updated_at: c.updated_at,
            updated_by: c.updated_by,
            category_name: c.category_name,
            displayTimestamp: this.formatRawTimestamp(c.updated_at)
          }));
        }
        if (typeof res?.count === 'number') {
          this.commentCount = res.count;
        } else if (Array.isArray(res?.comments)) {
          this.commentCount = res.comments.length;
        }
        this.loading = false;
        this.dialogRef.close(validComments);
      },
      error: (err: any) => {
        this.loading = false;
        try {
          const msg = err && err.message ? err.message : 'Failed to add comment';
          this._snackBar.open(msg, 'ok', { duration: 4000 });
        } catch (e) {
          // ignore snackbar failures
        }
      }
    });
  }
  addComment() {
    const now = new Date().toISOString();
    this.comments.push({
      text: '',
      updatedBy: this.data?.updated_by || 'Unknown',
      timestamp: now
    });
  }

  removeComment(index: number) {
    if (this.comments.length > 1) {
      this.comments.splice(index, 1);
    }
  }

  close() {
    this.dialogRef.close();
  }

  private formatRawTimestamp(ts: string | undefined | null): string {
    if (!ts) return '-';
    const m = ts.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/);
    if (!m) return ts;
    const [, y, mo, d, hh, mm] = m;
    return `${y}/${mo}/${d}, ${hh}:${mm}`;
  }
}
